import { Address } from 'models/Address/address.model';
import { serializable, alias, object, list, primitive } from 'serializr';

export class ProcessingFacility {
  @serializable(alias('id', primitive()))
  id?: number;

  @serializable(alias('name', primitive()))
  name?: string;

  @serializable(alias('company_id', primitive()))
  companyId?: number;

  @serializable(alias('scope1', primitive()))
  scope1?: string;

  @serializable(alias('scope1_unit', primitive()))
  scope1Unit?: string;

  @serializable(alias('scope2', primitive()))
  scope2?: string;

  @serializable(alias('total', primitive()))
  total?: number;

  @serializable(alias('scope2_unit', primitive()))
  scope2Unit?: string;

  @serializable(alias('address', object(Address)))
  address?: Address;

  @serializable(alias('createdAt', primitive()))
  createdAt?: string;

  @serializable(alias('updatedAt', primitive()))
  updatedAt?: string;

  @serializable(alias('scope_fields', primitive()))
  scope_fields?: string;
}
